<ion-button [disabled]="disabled" class="button-color-transparent text-color-primary">
  <icon-wrapper [slot]="slot" [icon]="icon" [custom]="custom"
    [ngClass]="text != null ? 'slot-icon-padding' : ''"></icon-wrapper>
  <span *ngIf="text" class="button-font-size-s">{{text}}</span>
</ion-button>